/**
 * @param {String} s
 * @return {any}
 */
export const safeParseJSON = (s) => {
  try {
    return JSON.parse(s)
  } catch (_e) {
    return null
  }
}
